import { useTranslation } from 'react-i18next';
import type { SettingType } from '@/types/app';
import SummaryCard from '../SummaryCard';
import Absence from './Summary';

interface SummaryProps {
	activeSetting: SettingType | null;
	handleSettingClick: (setting: SettingType) => void;
	absenceInfoSource: string | null;
	loading: boolean;
	idx: number;
	isConfirmed?: boolean;
}

const Summary = ({
	activeSetting,
	handleSettingClick,
	absenceInfoSource,
	loading,
	idx,
	isConfirmed = false
}: SummaryProps) => {
	const { t } = useTranslation();

	return (
		<SummaryCard
			type="absence"
			title={t('quotes.settings.absence.title')}
			onClick={handleSettingClick}
			isActive={activeSetting === 'absence'}
			source={absenceInfoSource}
			loading={loading}
			idx={idx}
			isConfirmed={isConfirmed}
		>
			<Absence />
		</SummaryCard>
	);
};

export default Summary;
